<div class="ft-form">
    <div class="content">
        <!-- form title -->
        <div class="ft-form-row">
            <span class="title">{{data.title}}</span>
        </div>
        <div class="ft-form-row col2-vf">
            <div class="border-outline">
                <img [src]="citation?.sourceBase?.mediaUrl ? citation?.sourceBase?.mediaUrl : '/assets/images/icons/source.svg'" style = "width: 125px;" />
            </div>            
            <div class="ft-form-row col1-v100" style="align-items: center;">
                <div class="ft-form-input">
                    <label id="citation-source-title">{{citation?.sourceBase?.title}}</label>
                </div>
           </div>     
        </div>

        <div class="ft-form-row col1-v100">                    
            <div class="ft-form-input">
                <label>{{"lbl_quality" | translate}}</label>
                <!-- <input type="text" [(ngModel)]="citation.type" #type="ngModel" name="type"> -->
                <select id="citation-quality" [(ngModel)]="selectedQuality">
                    <option *ngFor="let item of citationQualities" [ngValue]="item">
                        {{item.name | translate}}</option>
                </select>
            </div>                      
        </div>        
        <div class="ft-form-row col1-v100">                    
            <div class="ft-form-input">
                <label>{{"lbl_book_page" | translate}}</label>
                <input type="text" [(ngModel)]="citation.volume" #volume="ngModel" id="citation-page" name="volume">
            </div>                      
        </div>        
        <div class="ft-form-row col1-v100">                    
            <div class="ft-form-input">
                <label>{{"lbl_url" | translate}}</label>
                <input type="text" [(ngModel)]="citation.url" #url="ngModel" id="citation-url" name="url">
            </div>                      
        </div>        
        <div class="ft-form-row col1-v100">                    
            <div class="ft-form-input">
                <label>{{"lbl_comment" | translate}}</label>
                <input type="text" [(ngModel)]="citation.comment" #comment="ngModel" id="citation-comment" name="comment">
            </div>                      
        </div>        
    </div>
    <div class="footer">
        <button id="citation-save" class="ft-btn ft-btn-inactive active" (click)="save()">{{"lbl_save" | translate}}</button>
        <button id="citation-cancel" class="ft-btn ft-btn-active-not-selected" (click)="cancel()">{{"lbl_cancel" | translate}}</button>
    </div>
</div>